module.exports = __webpack_public_path__ + "media/images/services/terms3-30db4730183f37a2edd5cdb94387410d.png";